



































import BaseComponent from "@/asdcom/BaseComponent";
import { Prop, Component } from "vue-property-decorator";
import util from "@/lib/util";
import {
  IDistrictDto,
  DistrictDto
} from "@/asdcom/apiproxy/apiproxy.dto";

interface IViewModel {
  districtList: any[];
  searchCriteria: null | string;
}

@Component
export default class Configuration extends BaseComponent {
  openNodes: any[] = [];
  viewModel = {
    districtList: [],
    searchCriteria: null
  } as IViewModel;

  async created() {
    /// get items from server.
    const districtList = await this.$appsvs.vcpOnlineOkStaff.retrieveDistrictList();

    /// create tree model.
    districtList.forEach((i, ix) => {
      let users: any[] = [];
      let counties: any[] = [];

      /// add users to children array.
      if (!!i.staffUsers) {
        i.staffUsers.forEach((u, uid) => {
          users.push({
            id: uid,
            name: `${u.userName} (${u.email})`,
            itemType: "user"
          });
        });
      }

      /// add counties to children array.
      if (!!i.okCounties) {
        i.okCounties.forEach((c, cid) => {
          counties.push({
            id: cid,
            name: `${c.countyName}, ${c.phoneNumber}`,
            itemType: "county"
          });
        });
      }

      /// create new item.
      let newItem = {
        id: i.id,
        name: i.displayName,
        itemType: "district",
        children: [
          { id: 1, name: "Users", children: users },
          { id: 2, name: "Counties", children: counties }
        ]
      };
      /// add new item to tree model.
      this.viewModel.districtList.push(newItem);
    });
  }
}
